import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainContext from "./context/main/mainContext";

const AdminLogin = () => {
  const mainContext = useContext(MainContext);

  const { id } = useParams();

  const {
    getLoginToken,
    member,
    isProd,
    getMemberById,
    user,
  } = mainContext;

  const adminLogin = (uid, isStaging) => {
    getLoginToken(uid, (err, token) => {
      if (err) {
        alert(err);
      }

      let baseUrl = "https://admin.popl.co/";
      if (!isProd) {
        baseUrl = "https://dev-teams.popl.co/";
      }
      if (isStaging) {
        baseUrl = "https://staging-teams.popl.co/";
      }
      // Redirect this tab
      const url = new URL(`${baseUrl}sign-in`);
      url.searchParams.append("addon", token);
      url.searchParams.append("poplAdminUser", user.email);
      window.open(url.href, "_blank");
    });
  };

  useEffect(() => {
    if (!member?.member?.uid) {
      return;
    }
    adminLogin(member?.member?.uid, false);
  }, [member]);

  useEffect(() => {
    if (!id) {
      return;
    }
    const idInt = Number.parseInt(id, 10);
    getMemberById(idInt, (err) => {
      if (err) {
        alert(err);
      }
    });
  }, [id]);

  return (
    <div className="projectContainer">
      <p>Loading...</p>
    </div>
  );
};

export default AdminLogin;
